// ./src/contexts/InventoryItemsContext/InventoryItemsContext.tsx
//
// Thin context wrapper around the useInventoryItems hook. All derived data lives in
// the hook itself. Mirrors RentalAssetsContext — mounted on the account Library page
// and (with an eventId) on the event Inventory page so its item picker can list +
// create items in place.

import React, { createContext, useContext } from "react";

import { useInventoryItems, UseInventoryItemsOptions, UseInventoryItemsReturn } from "@/hooks/useInventoryItems";

const InventoryItemsContext = createContext<UseInventoryItemsReturn | null>(null);

export interface InventoryItemsProviderProps extends UseInventoryItemsOptions {
  children: React.ReactNode;
}

export const InventoryItemsProvider: React.FC<InventoryItemsProviderProps> = ({ children, ...options }) => {
  const value = useInventoryItems(options);

  return <InventoryItemsContext.Provider value={value}>{children}</InventoryItemsContext.Provider>;
};

export const useInventoryItemsContext = (): UseInventoryItemsReturn => {
  const context = useContext(InventoryItemsContext);

  if (!context) {
    throw new Error(
      "useInventoryItemsContext must be used within an <InventoryItemsProvider>. " +
        "Wrap your component tree with <InventoryItemsProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalInventoryItemsContext = (): UseInventoryItemsReturn | null => {
  return useContext(InventoryItemsContext);
};
